import axios from 'axios';
import getCaseManagerUrl from './caseManagerUrl';
import { configureHttpHeaders } from './apiHelpers';

const baseUrl = getCaseManagerUrl();


export function addNewTransaction(transactionObject) {
  configureHttpHeaders(axios);
  return post('api/v1/casemanager/case/manual/transaction', transactionObject.matchTransWithUnmatchedCase);
}

function get(url) {
  return axios
    .get(`${baseUrl}${url}`)
    .then(onSuccess)
    .catch(onError);
}
function post(url, user) {
  return axios
    .post(`${baseUrl}${url}`, user)
    .then(onSuccess)
    .catch(onError);
}

function onSuccess(response) {
  let result;
  if (response.status !== 204) {
    result = response.data;
  } else {
    result = 'Success';
  }
  return result;
}

function onError(error) {
  const returnedError = error && error.response && error.response.data;
  throw returnedError;
}

